/**
 * Shallowly compares two selection objects.
 *
 * Returns `true` when both objects have the same number of own enumerable keys and every key in `next` holds a value
 * that is identical (via `Object.is`) to the value under the same key in `previous`. Nested objects are compared by
 * reference, not by value.
 */
export const isSameSelection = <S extends object>(previous: S, next: S) => {
  const previousKeys = Object.keys(previous) as (keyof S)[];
  const nextKeys = Object.keys(next) as (keyof S)[];

  return previousKeys.length === nextKeys.length && nextKeys.every((key) => Object.is(previous[key], next[key]));
};
